import { goTo } from '@adornis/router/client/open-href.js';
import { type CampusLevumiLevel } from '@chancenwerk/campus-learning-content/entities/levumi/CampusLevumiLevel.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-link.js';
import '@chancenwerk/design/components/fonts.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('campus-dialog-show-levumi-difficulty-info')
export class CampusDialogShowLevumiDifficultyInfo extends ChromiumDialog<void> {
  @property() public levumiLevel: CampusLevumiLevel | undefined;

  static override get element_name() {
    return 'campus-dialog-show-levumi-difficulty-info';
  }

  override content() {
    return html` <cr-flex space="md" padding="md" vertical>
      ${(this.levumiLevel?.subject === 'german' && this.levumiLevel.level === 'N2') || this.levumiLevel?.level === 'N4'
        ? this._showGermanN2N4Info()
        : nothing}
      ${this.levumiLevel?.subject === 'german' && this.levumiLevel.level === 'N6' ? this._showGermanN6Info() : nothing}
      ${this.levumiLevel?.subject === 'math' ? this._showMathInfo() : nothing}
      ${this.levumiLevel?.subject === 'number_dictation' ? this._showNumberDictationInfo() : nothing}
      <cr-flex space="md" horizontal space-between center crossaxis-center>
        <div></div>
        <cr-button mode="outline" @click=${() => this.close()}>Schließen</cr-button>
      </cr-flex>
    </cr-flex>`;
  }

  private _showGermanN2N4Info() {
    return html`
      <cr-flex space="md" padding="md" center crossaxis-center space-between>
        <cr-text>
          Die Testkonstruktion inkl. der Testitems (exkl. Layout und Grafik) des Tests „ChancenKURVE Leseverstehen“ ist
          dem Material aus „Jungjohann, J. & Gebhardt, M. (2019). SinnL-Levumi. Tests zum sinnkonstruierenden Satzlesen
          als Lernverlaufsdiagnostik – „Sinnkonstruierendes Satzlesen“ der Onlineplattform
          <cr-link @click=${() => goTo('https://www.levumi.de')}> www.levumi.de </cr-link>
          [Verfahrensdokumentation, Manuskript, Tests der Niveaustufen N2 und N4 jeweils mit den Testversionen A-D mit
          Auswertungsbögen sowie Handbuch für Lehrkräfte]. In Leibniz-Institut für Psychologie (ZPID) (Hrsg.), Open Test
          Archive. Trier: ZPID.
          <cr-link @click=${() => goTo('https://doi.org/10.23668/psycharchives.4749')}>
            https://doi.org/10.23668/psycharchives.4749
          </cr-link>
          “ ohne Änderungen entnommen, genutzt von Chancenwerk e.V. nach CC BY-NC-SA 4.0. Die Testkonstruktion und die
          Testitems des Tests „ChancenKURVE Leseverstehen“ stehen ebenfalls unter der Lizenz CC BY-NC-SA 4.0.
          Chancenwerk e.V.
        </cr-text>
      </cr-flex>
    `;
  }

  private _showGermanN6Info() {
    return html`
      <cr-flex space="md" padding="md" center crossaxis-center space-between>
        <cr-text>
          Die Testkonstruktion inkl. der Testitems (exkl. Layout und Grafik) des Tests „ChancenKURVE Leseverstehen“ ist
          dem Material aus „Jungjohann, J. & Gebhardt, M. (2021). SinnL-Levumi N6 - Tests zum sinnkonstruierenden Lesen
          als Lernverlaufsdiagnostik – „Sinnkonstruierendes Satzlesen“ der Onlineplattform
          <cr-link @click=${() => goTo('https://www.levumi.de')}> www.levumi.de </cr-link>. Beschreibung der
          Testkonstruktion sowie der Items der Tests „Sinnkonstruierendes Satzlesen“ der Niveaustufe N6 in deutscher
          Sprache.
          <cr-link @click=${() => goTo('https://doi.org/10.5283/epub.47877')}>
            https://doi.org/10.5283/epub.47877
          </cr-link>
          “ ohne Änderungen entnommen, genutzt von Chancenwerk e.V. nach CC BY-NC-SA 4.0. Die Testkonstruktion und die
          Testitems des Tests „ChancenKURVE Leseverstehen“ stehen ebenfalls unter der Lizenz CC BY-NC-SA 4.0.
          Chancenwerk e.V.
        </cr-text>
      </cr-flex>
    `;
  }

  private _showMathInfo() {
    return html`
      <cr-flex space="md" padding="md" center crossaxis-center space-between>
        <cr-text>
          Die Testkonstruktion inkl. der Testitems (exkl. Layout und Grafik) des Tests „ChancenKURVE Kopfrechnen:
          Addition“ist dem Material aus „Buchwald, K. & Gebhardt, M. (2022). PaM100-Levumi. Tests Platzhalteraufgaben
          zur Lernverlaufsdiagnostik – „Platzhalter Addition (Zahlenraum 100)“ der Onlineplattform
          <cr-link @click=${() => goTo('https://www.levumi.de')}> www.levumi.de </cr-link>,
          <cr-link @click=${() => goTo('https://doi.org/10.5283/epub.52065')}>
            https://doi.org/10.5283/epub.52065
          </cr-link>
          “ ohne Änderungen entnommen, genutzt von Chancenwerk e.V. nach CC BY-NC-SA 4.0. Die Testkonstruktion und die
          Testitems des Tests „ChancenKURVE Kopfrechnen: Addition“ stehen ebenfalls unter der Lizenz CC BY-NC-SA 4.0.
          Chancenwerk e.V.
        </cr-text>
      </cr-flex>
    `;
  }

  // TODO insert info text
  private _showNumberDictationInfo() {
    return html`
      <cr-flex space="md" padding="md" center crossaxis-center space-between>
        <cr-text> Hier fehlt noch der Informationstext 😭 </cr-text>
      </cr-flex>
    `;
  }
}
